<template>
  <v-expansion-panels v-model="openPanels" multiple class="mb-4">
    <v-expansion-panel value="usage">
      <v-expansion-panel-title>
        <div class="d-flex align-center">
          <v-icon start>mdi-help-circle-outline</v-icon>
          {{ $t('routes.webhookIntegrations.usageHelpTitle') }}
        </div>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-alert type="info" variant="tonal" density="comfortable" class="mb-4 webhook-usage-help-intro">
          {{ $t('routes.webhookIntegrations.usageHelpIntro') }}
        </v-alert>

        <v-row>
          <v-col cols="12" md="6">
            <h3 class="text-subtitle-1 mb-2">{{ $t('routes.webhookIntegrations.usageWorkflowTitle') }}</h3>
            <ol class="webhook-usage-help-list">
              <li v-for="item in workflowItems" :key="item">{{ item }}</li>
            </ol>
          </v-col>
          <v-col cols="12" md="6">
            <h3 class="text-subtitle-1 mb-2">{{ $t('routes.webhookIntegrations.usageEndpointUrlTitle') }}</h3>
            <p>{{ $t('routes.webhookIntegrations.usageEndpointUrlBody') }}</p>

            <h3 class="text-subtitle-1 mb-2">{{ $t('routes.webhookIntegrations.usageSecretTitle') }}</h3>
            <p>{{ $t('routes.webhookIntegrations.usageSecretBody') }}</p>

            <h3 class="text-subtitle-1 mb-2">{{ $t('routes.webhookIntegrations.usageDirectoryTitle') }}</h3>
            <p class="mb-0">{{ $t('routes.webhookIntegrations.usageDirectoryBody') }}</p>
          </v-col>
        </v-row>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'WebhookUsageHelp',
  data() {
    return {
      openPanels: [],
    };
  },
  computed: {
    workflowItems() {
      return [1, 2, 3, 4, 5, 6].map((step) => this.$t(`routes.webhookIntegrations.usageWorkflowStep${step}`));
    },
  },
}
</script>

<style scoped lang="scss">
.webhook-usage-help-list {
  padding-left: 20px;
}

.webhook-usage-help-intro {
  color: var(--tw-text-color-primary);
}

.webhook-usage-help-list li:not(:last-child) {
  margin-bottom: 6px;
}
</style>
